if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                viewer: this.querySelector('[id^="GalleryViewer"]'),
                thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
                thumbnails2: this.querySelector('[id^="GalleryThumbnails2"]')
            }
            this.mql = window.matchMedia('(min-width: 750px)');
            if (!this.elements.thumbnails) return;

            this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
            this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
                mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false))
            });
            if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
            this.initDot()
            this.dotChange()
            this.elements.viewer
                .querySelector(".prevButton")
                .addEventListener("click", () => {
                    this.prevSlide();
                });
            this.elements.viewer
                .querySelector(".nextButton")
                .addEventListener("click", () => {
                    this.nextSlide();
                });
        }

        initDot() {
            const slides2 = this.elements.thumbnails2.querySelectorAll("li");
            const initializeIndex = 0;
            this.elements.thumbnails2.querySelectorAll("li").forEach((element) => {
                element.classList.remove('is-active');
            })
            const initializeDot = slides2[initializeIndex];

            initializeDot.classList.add('is-active');
        }

        dotChange() {
            this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
                mediaToSwitch.querySelector('button').addEventListener('click', () => {
                    const slides2 = this.elements.thumbnails2.querySelectorAll("li");
                    const dotIndex = mediaToSwitch.dataset.mediaPosition - 1
                    const nextSlide2 = slides2[dotIndex];
                    this.elements.thumbnails2.querySelectorAll("li").forEach((element) => {
                        element.classList.remove('is-active');
                    })
                    nextSlide2.classList.add('is-active');
                })
            });
        }
        // 切换下一张的逻辑
        nextSlide() {
            const slides = this.elements.viewer.querySelectorAll("li");
            const slides2 = this.elements.thumbnails2.querySelectorAll("li");

            if (!slides.length) return;
            const currentSlideIndex = Array.from(slides).indexOf(
                this.elements.viewer.querySelector(".is-active")
            );
            if (currentSlideIndex === -1) {
                currentSlideIndex = 0;
            }
            let nextSlideIndex = (currentSlideIndex + 1) % slides.length;
            if (nextSlideIndex === slides.length) {
                nextSlideIndex = 0;
            }
            const nextSlide = slides[nextSlideIndex];
            const nextSlide2 = slides2[nextSlideIndex];

            this.elements.thumbnails2.querySelectorAll("li").forEach((element) => {
                element.classList.remove('is-active');
            })
            nextSlide2.classList.add('is-active');

            this.setActiveMedia(nextSlide.dataset.mediaId, false);
        }

        // 切换上一张的逻辑
        prevSlide() {
            const slides = this.elements.viewer.querySelectorAll("li");
            const slides2 = this.elements.thumbnails2.querySelectorAll("li");

            if (!slides.length) return;
            const currentSlideIndex = Array.from(slides).indexOf(
                this.elements.viewer.querySelector(".is-active")
            );
            if (currentSlideIndex === -1) {
                currentSlideIndex = slides.length - 1;
            }

            let prevSlideIndex =
                (currentSlideIndex - 1 + slides.length) % slides.length;

            const prevSlide = slides[prevSlideIndex];
            const prevSlide2 = slides2[prevSlideIndex];


            this.elements.thumbnails2.querySelectorAll("li").forEach((element) => {
                element.classList.remove('is-active');
            })
            prevSlide2.classList.add('is-active');
            this.setActiveMedia(prevSlide.dataset.mediaId, false);
        }

        onSlideChanged(event) {
            const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
            this.setActiveThumbnail(thumbnail);
        }

        setActiveMedia(mediaId, prepend) {
            // 添加空值检查
            if (!mediaId) {
                console.error('mediaId is null or undefined');
                return;
            }

            const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

            // 添加元素存在性检查
            if (!activeMedia) {
                console.error(`Media element with data-media-id="${mediaId}" not found`);
                return;
            }

            this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
                element.classList.remove('is-active');
            });
            activeMedia.classList.add('is-active');

            if (prepend) {
                activeMedia.parentElement.prepend(activeMedia);
                if (this.elements.thumbnails) {
                    const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                    activeThumbnail.parentElement.prepend(activeThumbnail);
                }
                if (this.elements.viewer.slider) this.elements.viewer.resetPages();
            }

            this.preventStickyHeader();
            window.setTimeout(() => {
                if (this.elements.thumbnails) {
                    activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
                }
                if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
                    activeMedia.scrollIntoView({ behavior: 'smooth' });
                }
            });
            this.playActiveMedia(activeMedia);

            if (!this.elements.thumbnails) return;
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            this.setActiveThumbnail(activeThumbnail);
            this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }

        setActiveThumbnail(thumbnail) {
            if (!this.elements.thumbnails || !thumbnail) return;

            this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
            thumbnail.querySelector('button').setAttribute('aria-current', true);
            if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

            this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }

        announceLiveRegion(activeItem, position) {
            const image = activeItem.querySelector('.product__modal-opener--image img');
            if (!image) return;
            image.onload = () => {
                this.elements.liveRegion.setAttribute('aria-hidden', false);
                this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
                    '[index]',
                    position
                );
                setTimeout(() => {
                    this.elements.liveRegion.setAttribute('aria-hidden', true);
                }, 2000);
            };
            image.src = image.src;
        }

        playActiveMedia(activeItem) {
            window.pauseAllMedia();
            const deferredMedia = activeItem.querySelector('.deferred-media');
            if (deferredMedia) deferredMedia.loadContent(false);
        }

        preventStickyHeader() {
            this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
            if (!this.stickyHeader) return;
            this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }

        removeListSemantic() {
            if (!this.elements.viewer.slider) return;
            this.elements.viewer.slider.setAttribute('role', 'presentation');
            this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
        }
    });
}
